import React, {useEffect, useState} from 'react';
import { MsalProvider, useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { useNavigate } from 'react-router-dom';
import Logo from "../../../stories/assets/wisesenseLogoMini.svg";
import Barcoding from "../../../stories/assets/barcoding.svg";
import DecisionPoint from "../../../stories/assets/decisionPoint.png";
import LogoWhite from "../../../stories/assets/wisesense.svg";
import { useLoginStyles } from './loginPageStyles';
import { Box, Typography } from "@mui/material";
import { http } from "../../../clients/http/http.client";
import { HTTP_ENDPOINTS, WEB_STORAGE_KEYS } from "../../../clients/clients.constants";
import {setUser} from "../../../store/userSlice";
import {useDispatch} from "react-redux";

function Login() {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const styles = useLoginStyles;
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    // Redirect the user to the API login endpoint (which in turn redirects to Azure AD)
    window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/login`;
  };

  const isRedirecting = () => {
    return window.location.hash.includes("id_token") || window.location.hash.includes("access_token");
  };

  if (isRedirecting()) {
    return <div>Loading...</div>;
  }

  return (
    <div style={styles.loginContainer}>
      <div style={styles.loginLeft}>
        <div style={styles.loginBox}>
          <Box component="img" src={Logo} sx={{ height: '93px', transform: "translateX(10)", marginBottom: '15px' }} alt="WiseSense Logo" />
          <Typography variant="h4" sx={{ marginBottom: '20px', textAlign: 'center', fontWeight: '600', color: 'rgb(27, 54, 101)' }}>Sign in</Typography>
          <p style={styles.loginInfo}>
            Welcome to <b>WiseSense cloud</b> <br/>Enter your username and password, and click on the "Sign in* button to login to the WiseTrack platform.
          </p>
          <form style={styles.form}>
            {/*<label style={styles.label}>Email *</label>*/}
            {/*<input*/}
            {/*  type="email"*/}
            {/*  value={email}*/}
            {/*  onChange={(e) => setEmail(e.target.value)}*/}
            {/*  placeholder="admin@wisesense.com"*/}
            {/*  style={styles.input}*/}
            {/*/>*/}
            {/*<label style={styles.label}>Password *</label>*/}
            {/*<input*/}
            {/*  type="password"*/}
            {/*  value={password}*/}
            {/*  onChange={(e) => setPassword(e.target.value)}*/}
            {/*  style={styles.input}*/}
            {/*/>*/}

            {/*{error && <p style={{ color: 'red' }}>{error}</p>}*/}
            <button
              type="submit"
              style={styles.loginButton}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation()
                handleLogin()
              }}
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
      <div style={styles.loginRight}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '50px', gap: '100px' }}>
          <Box component="img" sx={{ height: '60px' }} src={LogoWhite} alt="WiseSense LogoWhite" />
          <Box component="img" sx={{ height: '60px' }} src={DecisionPoint} alt="DecisionPoint" />
        </Box>
        <h1 style={styles.loginRightTitle}>The Future of Retail Experience</h1>
      </div>
    </div>
  );
}

export default Login;
